import * as React from 'react';
import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Input } from './input';

interface PasswordInputProps extends React.ComponentProps<'input'> {
  forceVisible?: boolean;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, forceVisible, onKeyDown, ...props }, ref) => {
    const [visible, setVisible] = useState(false);
    const [capsLock, setCapsLock] = useState(false);

    const isVisible = forceVisible || visible;

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
      setCapsLock(e.getModifierState('CapsLock'));
      onKeyDown?.(e);
    };

    return (
      <div className="relative">
        <Input
          {...props}
          ref={ref}
          type={isVisible ? 'text' : 'password'}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          onKeyDown={handleKeyDown}
          className={cn(isVisible && 'font-mono pr-10', !isVisible && 'pr-10', className)}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={() => setVisible((v) => !v)}
          className="absolute right-0 top-0 h-full px-3 touch-target flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors"
          aria-label={isVisible ? 'Ascunde parola' : 'Arată parola'}
        >
          {isVisible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
        </button>
        {capsLock && (
          <p className="text-amber-500 text-xs mt-1">
            ⚠ CapsLock este activat
          </p>
        )}
      </div>
    );
  }
);
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
export type { PasswordInputProps };
